export class HttpAttachment {
  downloadUrl: string
  filename: string

  constructor(downloadUrl: string, filename: string) {
    this.downloadUrl = downloadUrl
    this.filename = filename
  }

  static async fromResponse(response: Response): Promise<HttpAttachment> {
    const contentType = `${response.headers.get('Content-Type') ?? 'text/plain'}; base64`
    const contentDisposition = response.headers.get('Content-Disposition')
    const filename = contentDisposition?.split('filename=')[1]
    const downloadUrl = `data:${contentType},${await response.text()}`

    return new HttpAttachment(downloadUrl, filename ?? '')
  }

  download(): void {
    const downloadLink = document.createElement('a')
    downloadLink.href = this.downloadUrl
    downloadLink.download = this.filename
    downloadLink.click()
  }
}
